import Page from "../../components/Page";

export default function Frequently() {
  return (
    <Page title="Frequently Asked Questions">
   
      <p>
        <b>Question - How do vegetarians and vegans get enough protein?</b>
      </p>
      <br />
      <p>
        Much confusion exists with regard to human protein needs. One otherwise
        very helpful book, written in the 1960s, called{" "}
        <b>Diet for a Small Planet,</b> actually added to that confusion by
        needlessly emphasizing the practice of combining various complementary
        plant proteins, such as beans with rice, in order to create "complete
        proteins".
      </p>
      <br />
      <p>
        The <b>American Dietetic Association</b>, and nearly all other
        authorities on nutrition, now says that we needn't concern ourselves
        with such complicated practices, and that we will get all the complete
        proteins we need as long as we eat a variety of plant foods throughout
        the day. In fact, if we are getting all the calories that we need, we
        will almost certainly get enough protein.
      </p>
      <br />
      <p>
        {" "}
        Another large point of confusion in Western culture is about exactly how
        much protein humans need. In infancy, we humans grow faster than at any
        other time in our lives. And presumably, that would be the time period
        in which our protein requirements would be the greatest. But the protein
        content of human mothers' breast milk comprises only 5% of the calories
        of that food source.
      </p>
      <br />
      <p>
        The <b>World Health Organization</b> says that we only need 4 1/2 % of
        our calories to come from protein. Most Americans get from 15% - 17 % of
        their daily calories from protein, and that's actually harmful,
        especially when the protein is coming mainly from animal sources.
      </p>
      <br />
      <p>
        Problems commonly associated with the over-consumption of protein
        include gout, osteoporosis, kidney stones, and kidney disease.
      </p>
      <br />
      <p>
        <b>Dr. T. Colin Campbell,</b> director of the{" "}
        <b>Cornell/Oxford/China Health Project,</b> states that the consumption
        of animal protein causes more cancers than does any chemical carcinogen.
        Dr. Campbell's book, The China Study, gives the details of that huge,
        comprehensive study.
      </p>
      <br />
      <p>
        <b>
          Question - How could meat eating be wrong when it is sanctioned by
          God's Word, the Holy Bible?
        </b>
      </p>
      <br />
      <p>
        The brutality of factory farms - the source of nearly all meat, dairy,
        and eggs - is flagrantly at odds with God's repeated calls for mercy and
        peace.
      </p>
      <br />
      <p>
        After the flood, God's "choice" is merely a concession to human
        savagery, and it comes with a dreadful curse - the dissolution of our
        bond with animals and the earth - a terrible price to pay. Only if we
        twist God's word to rationalize our addiction to cruel animal products
        could we fool ourselves - at least superficially - into believing that
        God doesn't care if we are violent or peaceful, or if we intentionally
        cause harm or try to avoid it.
      </p>
      <br />
      <p>
        To consume animal products in order to survive is one thing. To engage
        in entirely avoidable meanness, in order to satisfy an indulgence, is
        quite another and violates the very essence of God's calls to be
        merciful and peaceful. To kill for pleasure exemplifies greed, a deadly
        sin, and blatantly goes against God's word.
      </p>
      <br />
      <p>
        <b>
          Question - What would we do with all the animals if everyone went
          vegetarian?
        </b>
      </p>
      <br />
      <p>
        It is true that animal overpopulation would be a major concern if
        everyone went vegetarian immediately. But such big changes are more
        likely to happen gradually, which would mean that farmers would just
        stop breeding so many animals for slaughter, and their populations would
        dwindle.
      </p>
      <br />
      <p>
        <b>
          {" "}
          Question - Aren't vegetarians being inconsistent when they show little
          or no concern for the suffering of plants?
        </b>
      </p>
      <br />
      <p>
        It is possible that plants have some degree of intelligence or
        sentience, though it is far from being fully understood. We know that
        plants do not have central nervous systems, as do humans and animals, so
        it would be difficult for us to imagine that plants might experience
        pain that is similar to our own.
      </p>
      <br />
      <p>
        We know that farmed animals have the same five senses as we, including
        two eyes, two ears, and a central nervous system; we know that they have
        individual personalities and a desire to enjoy being in nature, moving
        about freely, and doing the things that the source of all life has
        equipped them to do. Since it's very clear that they can suffer,
        wouldn't we want to do all that we can to mitigate that suffering and
        help bring them the same kinds of joys that we cherish...
      </p>
      <br />
      <p>
        Those who are truly concerned about the possible suffering of plants
        could greatly reduce plant suffering by eating fewer animal products.
        That dietary change would significantly reduce the number of corn, oats,
        and soybean plants that are killed each year to form the mountains of
        grains that are required to produce small amounts of meat.
      </p>
      <br />
      <p>
        They might even want to consider a diet of fruit, nuts, and seeds, which
        doesn't require the taking of animal or plant lives.
      </p>
    </Page>
  );
}
